import api from "./api";
import qsStringify from "./qsStringify";

export const getHome = locale => {
  const query = qsStringify({
    populate: [
      "seo",
      "seo.image",
      "glance",
      "glance.items",
      "glance.items.icon",
      "sustainability",
      "sustainability.items",
      "sustainability.items.icon",
      "about",
      "about.items",
      "about.items.img",
      "news",
      "news.thumbnail",
      "header",
      "header.carousel",
      "header.carousel.media",
      "header.helpBox",
      "header.helpBox.icon",
    ],
  });
  return api.get(`/page-home?locale=${locale}&${query}`).then(res => res.data);
};
